/* eslint-disable no-magic-numbers */
const LBS_USER_IDS = [20_001, 4];

export const TOKEN_TYPE_BEARER = 'bearer';

export enum Endpoints {
  Assignments = '/vm/assignments',
  AssignmentsType = '/assignments/type',
  Departments = '/vm/departments',
  Personnel = '/personnel',
  PersonnelSearch = '/vm/personnel/search',
  PersonnelType = '/personnel/type',
  Tally = '/vm/tally',
  Token = '/token',
  UserPassport = '/user/passport',
  Views = '/views',
  ViewsFilter = '/views/filter',
  ViewsPublic = '/views/public',
  ViewsTheme = '/views/theme',
  VMGiveSelfAccess = 'vm/view/access/giveself',
  VMPersonnel = '/vm/personnel',
  VMPersonnelAccess = '/vm/personnel/access',
  VMViewAccess = 'vm/view/access',
  VMViews = '/vm/views',
  VMViewsCreate = '/vm/views/create',
  VMViewsList = '/vm/views/list',
}

export enum RTKQueryTags {
  PublicViews = 'PublicViews',
  View = 'View',
  ViewsList = 'ViewsList',
}

export enum HeaderKeys {
  Accept = 'Accept',
  Authorization = 'Authorization',
  ContentType = 'Content-Type',
}

export enum ContentTypes {
  ApplicationJSON = 'application/json',
  FormEncoded = 'application/x-www-form-urlencoded;charset=utf-8',
}

export const AUTHENTICATION_ERROR_MESSAGE = 'Could not authenticate';
export const AUTHENTICATION_ERROR_ORIGIN = 'auth/login';

const APIConstants = {
  AUTHENTICATION_ERROR_MESSAGE,
  AUTHENTICATION_ERROR_ORIGIN,
  ContentTypes,
  Endpoints,
  HeaderKeys,
  LBS_USER_IDS,
  RTKQueryTags,
};

export default APIConstants;
